module.exports = __webpack_public_path__ + "fonts/Famirids..7c7a14a2.ttf";